import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/opel-second-hand-romania/")({
  head: () => routeHead("/opel-second-hand-romania/"),
  beforeLoad: () => {
    throw redirect({ href: "/cars/opel", statusCode: 301, replace: true });
  },
});
